module.exports = __webpack_public_path__ + "static/media/gmcab-card-logo.e04c348a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/gmcab-card-logo.png
// module id = 478
// module chunks = 0